import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {CuiPagetipComponent} from './pagetip.component';
import {CuiScrollContainer} from '../shared/scroll-container';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CuiPagetipComponent
  ],
  providers: [
    CuiScrollContainer
  ],
  exports: [
    CuiPagetipComponent
  ]
})
export class CuiPagetipModule {}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/pagetip/pagetip.module.ts